module.exports = __webpack_public_path__ + "img/bersneva.2cb2a4a3.jpg";